import { useSelector } from 'react-redux';
import { VEHICLE_FIELDS, WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';
import { getShowroomWorkflowStatus } from '../workflow/selector';
import type { DealValidationState } from './types';

export const useDealValidationSelector = () => {
    const state = useSelector(
        (state: SalesCheckinRootState) =>
            state.salesCheckin.dealValidation || ({ missingFields: [], valid: true } as DealValidationState)
    );
    return state;
};

/**
 * Whether the deal currently has no vehicle. True once the workflow has settled on
 * `MISSING_VEHICLE`, or earlier — before that status lands — as soon as deal validation
 * flags a vehicle field, so UI gated on this doesn't lag a beat behind the workflow evaluator.
 */
export const useIsMissingVehicle = (): boolean => {
    const workflowStatus = useSelector(getShowroomWorkflowStatus);
    const { missingFields } = useDealValidationSelector();
    return workflowStatus === WorkflowStatus.MISSING_VEHICLE || missingFields.some((field) => field.startsWith(VEHICLE_FIELDS));
};
